import React, { useState } from 'react';

import styled from '@emotion/styled';

import EyeIcon from '../Icons/EyeIcon';
import { Modal } from '../Modal/Modal';
import PdfPreviewerModal from './PdfPreviewerModal';

interface EyeIconWrapperProps {
  setShowModal: (...args: any) => void;
}

const EyeIconWrapper: React.FC<EyeIconWrapperProps> = ({ setShowModal }) => {
  return (
    <EyeIconArea onClick={() => setShowModal(true)}>
      <EyeIcon />
    </EyeIconArea>
  );
};

interface PreviewAblePdfProps {
  docUrl: string;
}
const PreviewAblePdf: React.FC<PreviewAblePdfProps> = ({ docUrl }) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <Container>
        <EyeIconWrapper setShowModal={setShowModal} />
        <PdfDiv onClick={() => setShowModal(true)}>
          <Pdf src={docUrl} title='PDF Preview' />
        </PdfDiv>
      </Container>

      <Modal showModal={showModal} setShowModal={setShowModal}>
        <PdfPreviewerModal docUrl={docUrl} />
      </Modal>
    </>
  );
};

export default PreviewAblePdf;

const Container = styled.div`
  display: grid;
  place-content: center;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-radius: 6px;
  padding: 9px 9px;
  height: 117px;
  width: 117px;

  & > * {
    grid-column: 1;
    grid-row: 1;
    border-radius: 4px;
  }
`;

const PdfDiv = styled.div`
  display: grid;
  place-content: center;
  height: 99px;
  width: 99px;
  overflow: hidden;
  cursor: pointer;
`;

const Pdf = styled.iframe`
  border: none;
  height: 99px;
  width: 99px;
  pointer-events: none;
`;
const EyeIconArea = styled.div`
  display: grid;
  place-content: center;
  background-color: rgba(0, 0, 0, 0.4);
  transition: 3s transform ease-in-out;
  z-index: 1;
  cursor: pointer;

  &:hover + * > img {
    transform: scale(110%);
  }

  & + * > img {
    transition: 0.3s transform ease-in-out;
  }
`;
